module.exports = "/shifts/shift-swap/search-bar-3f544f.html";